import { defineStore } from "pinia";
import api from "@/services/api";

export const useProfileStore = defineStore("profile", {
    state: () => ({
        profile: null,
        loading: false,
        fetchedAt: 0,
        ttl: 20 * 60_000
    }),

    persist: true,

    actions: {
        async fetchProfile(force = false) {
            const now = Date.now();
            if (!force && this.profile && now - this.fetchedAt < this.ttl) return; // cache 1 menit
        
            const res = await api.get('/profile/detail');
            this.profile = res.data.data;
            this.fetchedAt = now;
            try {
                const u = JSON.parse(localStorage.getItem('user') || '{}');
                if (u && this.profile?.permissions) {
                    u.permissions = this.profile.permissions;
                    localStorage.setItem('user', JSON.stringify(u));
                }
            } catch (e) {
                console.warn('Gagal sync user permissions ke localStorage:', e);
            }
        },
        hasPermission(perm) {
            if (!perm) return true;
            const perms = this.profile?.permissions || [];
            if (Array.isArray(perm)) {
                return perm.some(p => perms.includes(p));
            }
            return perms.includes(perm);
        },
        
        updateWalletBalance(newBalance) {
            if (this.profile) this.profile.wallet_balance = newBalance;
        },
        reset() {
            this.profile = null;
            this.fetchedAt = 0;
        }
    },
});